import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'inventory',
    'needsReloading',
    'loading'
  ]
}

const defaultStates = () => {
  return {
    inventory: [],
    needsReloading: true,
    loading: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setInventory (state, inventory) {
      state.inventory = inventory
      state.needsReloading = false
    }
  },
  actions: {
    async getInventory ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setLoading', true)
      const { status, payload } = await get('v1/inventory/all')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setInventory', payload.items || [])
      }
    }
  },
  getters: {
    getInventory: state => state.inventory,
    isLoading: state => state.loading
  }
}
